<template>
  <div class="content">
    <!-- start of left -->
    <div class="left-box back-color-fff" :class="isLeftOpen ? 'open': 'close'">
      <template v-if="isLeftOpen">
        <el-input size="mini"
          v-model.trim="leftPage.tenantName"
          placeholder="搜索公司名称"
          clearable
          @input="searchLeftData"
          @keyup.enter.native="searchLeftData"
        />

        <!-- 公司数据，可分页 -->
        <div class="left-box-list">
          <div class="left-total-box">共 {{ leftPage.totalRows }} 条数据</div>
          <div class="left-box-list-li">
            <div v-for="(item,index) in leftTenantList" :key="index" :class="item.guid == tenantGuid ? 'active': ''" @click="selectTenant(item)">
              {{ item.tenantName }}
            </div>
          </div>
          <el-pagination
            v-if="leftPage.totalRows > 0"
            layout="prev, pager, next"
            :pager-count="3"
            @size-change="leftSizeChange"
            @current-change="leftCurrentChange"
            :current-page="leftPage.pageIndex"
            :page-size="leftPage.pageSize"
            :total="leftPage.totalRows"
          >
          </el-pagination>
        </div>
      </template>

      <!-- start of open-close icon -->
      <img :src="isLeftOpen ? require('@/assets/icon-left.png'): require('@/assets/icon-right.png')" @click="isLeftOpen = !isLeftOpen" />
      <!-- end of icon -->
    </div>
    <!-- end of open-close icon -->

    <!-- start of right -->
    <div class="right-box" :style="{width: isLeftOpen ? 'calc(100% - 200px - 1px)': 'calc(100% - 1px)'}" >
      <div class="tenantname">{{ tenantName }}</div>
      <div class="tips-content">
        <div class="tips"  v-if="showTips">
          <div class="tips-left">
            <img src="../../assets/icon/import_warning.png"/>
            <p>【去管理】说明：点击后打开新页面时，如果发现没有左侧展示的此条记录，说明无此记录的查看权限。</p>
          </div>
          <div class="tips-right" @click="showTips=false;">
            <p>不在提醒</p>
            <img  src="../../assets/map/close_icon.png"/>
          </div>

        </div>
        <div class="search-title">
          <div class="title">
            平台任务管理流程七步骤
          </div>
          <el-date-picker v-model="page.month" type="month" format="yyyy年MM月" placeholder="请选择核算月份"
              style="width: 300px;" value-format="yyyy-MM" clearable/>
        </div>
        <div class="table-content" v-if="tableData.length">
          <div class="item" v-for="(item,index) in tableData" :key="index">
            <div class="item-child1" :style="item.content?'font-weight:bold;':'font-weight:normal;'">{{item.stepName}}</div>
            <div class="item-child2">{{item.content}}</div>
            <div class="item-child3" v-if="item.content" @click="$router.push(item.jumpUrl)">去管理>></div>
            <div class="item-child3" v-else style="color:#666;">暂无记录</div>
          </div>
        </div>
      </div>
     
      
    </div>
    <!-- end of right -->


  </div>
</template>
<script>
import { List } from 'echarts/lib/export';

export default {
  name: 'processSettings',
  data() {
    return {
      showTips:true,
      isLeftOpen: true, // 控制左侧企业数据是否展开
      tableData: [],
      page: { //控制右侧查询
        month:'',
        tenantGuid: ''
      },
      leftPage: {
        pageIndex: 1,
        pageSize: 15,
        totalRows: 0,
        queryAllServiceTenantFlag: false, // 是否查询所有的运营公司 true是 false否
        currentTenantGuid: localStorage.guid,
        tenantName: ''
      },
      leftTenantList: [],
      tenantName: '', // 公司名称
      tenantGuid: '', // 公司guid
    }
  },
  created() {
    this.searchLeftData();
  },
  watch:{
    "page.month"(newVAL){
        if(newVAL){
          this.getRightData();
        }
    }
  },
  methods: {
    searchLeftData() {
      this.leftPage['pageIndex'] = 1;
      this.leftPage['totalRows'] = 0;
      this.tableData = [];
      this.getLeftData();
    },
    /**
     * 左侧选择企业
     * @param {*} item 
     */
    selectTenant(item) {
      this.tenantGuid = item.guid;
      this.tenantName = item.tenantName;
      this.getRightData();
    },
    /**
     * 左侧分页
     * @param {*} val 
     */
    leftSizeChange(val) {
      this.leftPage.pageSize = val;
      this.getLeftData();
    },
    /**
     * 左侧分页
     * @param {*} val 
     */
     leftCurrentChange(val) {
      this.leftPage.pageIndex = val;
      this.getLeftData();
    },
    /**
     * 获取左侧列表数据
     */
    getLeftData(flag = true) {
      let that = this;
      that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`, that.leftPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res;
          if(data.data && data.data.records) {
            that.leftTenantList = data.data.records || [];
            that.leftPage.totalPage = data.data.totalPages;
            that.leftPage.totalRows =  data.data.totalRows;

            // 如果有数据
            if(data.data.records.length > 0) {
              if(flag) {
                that.tenantName = data.data.records[0].tenantName;
                that.tenantGuid = data.data.records[0].guid;
                that.getRightData();
              }
              
              // 获取右侧列表内容
              that.getRightData();
            }
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
     /**
     * 获取右侧数据
     */
     getRightData() {
      let self = this;
      this.page.tenantGuid = this.tenantGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/get-task-board`, this.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
}
</script>
<style lang="less" scoped>
.left-box, .right-box {
  float: left;
}


.left-box {
  width: 250px;
  height: calc(100vh - 60px - 30px);
  border-right: 1px solid #D9D9D9;
  position: relative;
  .el-input {
    width: calc(100% - 14px);
    margin: 10px auto 0px auto;
  }
  .left-box-list {
    text-align: left;
    .left-total-box {
      color: #999999;
      margin: 8px 10px;
      font-size: 12px;
    }
    .left-box-list-li {
      height: 70vh;
      overflow-y: auto;
      div {
        color: #666666;
        cursor: pointer;
        text-align: left;
        height: 32px;
        line-height: 32px;
        padding: 0px 10px;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; 
        &:hover {
          background-color: #EBF6F7;
          color: #4FA1A4;
        }
      }
      
      .active {
        background-color: #EBF6F7;
        color: #4FA1A4;
      }
    }
  }
  .el-pagination {
    position: absolute;
    bottom: 7px;
    z-index: 9;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background-color: #ffffff;
  }
  /deep/ .el-pagination .btn-prev, /deep/ .el-pagination .btn-next {
    padding: 0px;
    min-width: 25px;
  }
  /deep/ .el-pager li {
    min-width: 25px;
  }

  img {
    width: 24px;
    height: 58px;
    position: absolute;
    right: -5px;
    top: calc(50% - 29px);
    z-index: 99;
    cursor: pointer;
  }
}
.open {
  width: 200px;
  img {
    right: -5px;
    left: auto;
  }
}
.close {
  width: 0px;
  img {
    left: -5px;
    right: auto;
  }
}

.right-box {
  width: calc(100% - 250px - 1px);

  .content-main-box {
    // height: calc(100vh - 60px - 36px - 56px - 30px);

    .set-person {
      color: #4FA1A4;
      text-decoration: none;
      cursor: pointer;
    }
  }
  .el-pagination {
    border-top: 1px solid #D9D9D9;
    padding: 8px 0px;
  }
  .tenant-name {
    margin: 0 0 12px 0;
    text-align: left;
    font-size: 16px;
    color: #323233;
  }
}
.tenantname{
  font-size: 16px;
  color: #212121;
  letter-spacing: 0;
  line-height: 60px;
  font-weight: 600;
  background: #fff;
  height: 60px;
  text-align: left;
  padding-left: 20px;
  border-bottom: 1px solid #D9D9D9 ;
}
.tips{
  cursor: pointer;
}
.tips-content{
  background: #fff;
  padding:10px 20px;
}
.tips-content .tips{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFBF2;
  border: 1px solid rgba(255,241,212,1);
  padding:0 10px;
  border-radius: 4px;
}
.tips-content .tips-left{
  display: flex;
  align-items: center;
  
}
.tips-content .tips-left img{
  width: 16px;
}
.tips-content .tips-right{
  display: flex;
  align-items: center;
  color:#FF991C;
}
.tips-content .tips-right img{
  width: 12px;
  margin-left: 10px;
  cursor: pointer;
}
.search-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 16px;
}
/deep/ .el-range-editor.el-input__inner{
  
  width:200px
}
.table-content{
  margin:20px 0;
  border: 1px solid rgba(229,229,229,1);
  border-top: 0 none;

}
.table-content .item{
  padding:20px;
  border-top: 1px solid rgba(229,229,229,1);
  display: flex;

}
.table-content .item .item-child1{
    flex:2;
    text-align: left;
    font-weight: bold;
}
.table-content .item .item-child2{
    flex:7;
    text-align: left;
    color:#999999;
}
.table-content .item .item-child3{
    text-align: right;
    flex:1;
    color:#4FA1A4;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
}
</style>
